import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import type { ReactNode } from 'react'

import { cardReplayTheme } from './theme'

type AppThemeProviderProps = {
  children: ReactNode
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  return (
    <ThemeProvider
      defaultMode="light"
      disableTransitionOnChange
      theme={cardReplayTheme}
    >
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
